import { SelectField } from '@mews-commander/form';
import { LocalizedText } from '@mews/framework';
import { Option } from '@mews-commander/types';
import { TextKey } from '@mews-commander/enums';
import { useGetAssignablePropertyGroups } from '../queries';
import { ENTERPRISE_GROUPS_IDS_FIELD_NAME } from './schema';

interface PropertyGroupsSelectFieldProps {
    rateGroupId: string;
}

export const PropertyGroupsSelectField = ({ rateGroupId }: PropertyGroupsSelectFieldProps) => {
    const { data, isFetching } = useGetAssignablePropertyGroups({ centralRateGroupId: rateGroupId });

    const propertyGroups: Option[] =
        data?.propertyGroups?.map((propertyGroup) => ({
            disabled: false,
            inactive: false,
            indent: false,
            secondaryText: null,
            label: propertyGroup.name,
            value: propertyGroup.id,
        })) || [];

    return (
        <SelectField
            label={<LocalizedText textKey={TextKey.PropertyGroupsNavigation} />}
            multiselect
            loader={isFetching}
            name={ENTERPRISE_GROUPS_IDS_FIELD_NAME}
            options={propertyGroups}
            overlayMaxHeight={400}
        />
    );
};
